import { Skeleton } from '@/components/atoms/Skeleton';
import useBreakpoint, { breakpointDesktopDefault } from '@/hooks/useBreakpoint';

import { theme } from '@/styles/theme';

export default function FormDuvidasFallback() {
  const { breakpoint } = useBreakpoint();
  const breakpointDesktopStyle =
    breakpoint === 'desktop' ? breakpointDesktopDefault : {};
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: `${theme.spacing[5]}px ${theme.spacing[4]}px`,
        gap: theme.spacing[6],
        ...breakpointDesktopStyle,
      }}
    >
      <div>
        <Skeleton style={{ width: '65vw', height: 25 }} />
        <Skeleton style={{ height: 48, marginTop: theme.spacing[1] }} />
      </div>

      <div>
        <Skeleton style={{ height: 72 }} />
        <Skeleton style={{ height: 92, marginTop: theme.spacing[1] }} />
        <Skeleton style={{ height: 72, marginTop: theme.spacing[1] }} />
        <Skeleton style={{ height: 92, marginTop: theme.spacing[1] }} />
      </div>
    </div>
  );
}
